import ChevronLeft from 'svg/ChevronLeft';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';
import { SKILL_LEVEL_DESCRIPTIONS } from './data';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

/**
 * Explainer behind the "Learn more" link on the Skill level filter. Opens on top of
 * the filters modal, so the header uses a back chevron rather than a close X — the
 * filters stay mounted underneath.
 */
export default function SkillLevelInfoModal({ isOpen, closeModal }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={closeModal}
      classNameRounded="rounded-t-3xl sm:rounded-3xl"
      classNamePosition="relative"
      classNameMaxWidth="max-w-2xl"
    >
      <div className="relative flex h-full max-h-[90vh] flex-col overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-ds-xl md:px-ds-3xl">
          <ButtonText
            onClick={closeModal}
            className="rounded-full p-2 transition-colors hover:bg-color-bg-lightmode-secondary dark:hover:bg-color-bg-darkmode-secondary"
          >
            <ChevronLeft className="h-6 w-6" />
          </ButtonText>
          <p className="typography-product-heading flex-1 text-center text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Skill level
          </p>
          {/* Balances the back button so the title stays optically centred. */}
          <div className="h-10 w-10 shrink-0" aria-hidden="true" />
        </div>

        <div className="flex flex-col gap-ds-2xl overflow-y-auto px-4 pb-ds-3xl md:px-ds-3xl">
          {SKILL_LEVEL_DESCRIPTIONS.map((level) => (
            <div key={level.title}>
              <p className="typography-product-subheading mb-2 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                {level.title}
              </p>
              <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                {level.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
